import React from 'react';
import { Table } from 'semantic-ui-react';
import ListItem from './Item.js';
import { withNamespaces } from 'react-i18next';


const CompetitionsList = (props) => {
  const { t, disabled } = props;

  return (
    <div>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell collapsing/>
            <Table.HeaderCell>{t('private:addWorkshop.workshop')}</Table.HeaderCell>
            <Table.HeaderCell
              collapsing
              content={t('private:addWorkshop.time')}/>
            <Table.HeaderCell collapsing>{t('private:addWorkshop.vacancies')}</Table.HeaderCell>
            <Table.HeaderCell collapsing>{t('private:addWorkshop.organizer')}</Table.HeaderCell>
            <Table.HeaderCell collapsing>{t('private:addWorkshop.rules')}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          { props.data.map((c, ix) =>
                           <ListItem
                             key={ix}
                             ix={ix}
                             data={c}
                             disabled={disabled}
                             activeCompetitionId={props.activeCompetitionId}
                             onSelect={props.onSelect}
                           />)}
        </Table.Body>
      </Table>
    </div>
  );
};

export default withNamespaces('private')(CompetitionsList);



// WEBPACK FOOTER //
// ./src/private/common/components/Workshop/Form/Competition/Competitions/List.js